module.exports = __webpack_public_path__ + "static/media/Michelle_Adriana_Rosas_Gonzalez.b62abef7.jpg";